export default {
  download: 'Descargar',
}